export default "__VITE_ASSET__88025035__"